import { api } from '@/lib/http-client';
import type { AuthResult, LoginRequest, MeResult, RegisterRequest } from '@/types/auth';

/**
 * Módulo 1 — Auth (`docs/openapi.yaml` → tag `Auth`).
 * Las rutas van completas (con `/api`) para poder copiarlas tal cual del openapi.
 */

/** `POST /api/auth/login` — endpoint público. */
export function login(payload: LoginRequest): Promise<AuthResult> {
  return api.post<AuthResult>('/api/auth/login', payload, { auth: false });
}

/**
 * `POST /api/auth/register` — endpoint público.
 * Crea el usuario Y su primer tenant (el usuario queda como ADMIN de ese tenant).
 */
export function register(payload: RegisterRequest): Promise<AuthResult> {
  return api.post<AuthResult>('/api/auth/register', payload, { auth: false });
}

/** `GET /api/auth/me` — usuario autenticado + sus tenants. */
export function fetchMe(): Promise<MeResult> {
  return api.get<MeResult>('/api/auth/me');
}
